module.exports = __webpack_public_path__ + "static/media/myCV.352b8c38.pdf";